import React from 'react'
import { Box } from "@mui/material"
import { ButtonIconSeeker, LoadingIconSeeker } from "@ui-seeker/core"

import { loadingEditRowId, loadingRowId } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function actionsColumn(onDeleteAlert, onEditAlert) {
	return {
		label: 'Actions', name: "actions", options: {
			filter: false, customBodyRowRenderLite: (value, row) => <Box
				sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
				{loadingEditRowId.value === row.idAlert && <LoadingIconSeeker
					fontSize={16}
				/>}
				{loadingEditRowId.value !== row.idAlert && <ButtonIconSeeker
					icon="pen"
					tooltip="Edit the alert"
					iconProps={{ fontSize: 15, color: "warning.main" }}
					onClick={() => {
						onEditAlert(row.idAlert)
					}}
				/>}
				{loadingRowId.value !== row.idAlert && <ButtonIconSeeker
					icon="trash-can"
					tooltip="Delete the alert"
					iconProps={{ fontSize: 15, color: "error.main" }}
					onClick={() => onDeleteAlert(row.idAlert)}
				/>}
				{loadingRowId.value === row.idAlert && <LoadingIconSeeker
					fontSize={16}
				/>}
			</Box>
		}
	}
}